import { Omit } from "@material-ui/core";
import { FieldProps, getIn } from "formik";
import * as React from "react";

export type ClassNameMap<ClassKey extends string = string> = Record<
    ClassKey,
    string
>;

export type MergeTypes<F, S> = F & Omit<S, keyof F>;

export type ColorType =
    | "primary"
    | "secondary"
    | "danger"
    | "flat"
    | "inherit"
    | "default";

export const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});

export const currencyWholeDollarFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

export const currencyCompactFormatter = new Intl.NumberFormat("en-US", {
    notation: "compact",
    style: "currency",
    currency: "USD",
    currencyDisplay: "narrowSymbol",
});

export const numberCompactFormatter = new Intl.NumberFormat("en-US", {
    notation: "compact",
    style: "decimal",
});

export const percentCompactFormatter = new Intl.NumberFormat("en-US", {
    notation: "compact",
    style: "percent",
});

export const pascalCase = (str: string, toSentence: boolean = false) =>
    `${toSentence ? " " : ""}${str}`
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+(.)/g, (match: string, chr: string) =>
            chr.toUpperCase()
        );

export const camelize = (str: string) =>
    str.replace(/^([A-Z])|[\s-]+(\w)/g, (match, p1, p2, offset) => {
        if (p2) return p2.toUpperCase();
        return p1.toLowerCase();
    });

interface RenderFieldWithErrorHandlingOptions<Values = any> {
    props: FieldProps<Values>;
    Component: React.ComponentType<any>;
    ComponentProps: any;
    helperText?: string;
}

export const renderFieldWithErrorHandling = (
    options: RenderFieldWithErrorHandlingOptions
) => {
    const { props, Component, ComponentProps, helperText } = options;
    const { name } = props.field;
    const { touched, errors } = props.form;

    const fieldError = getIn(errors, name);
    const showError = getIn(touched, name) && !!fieldError;

    return (
        <Component
            {...ComponentProps}
            error={showError}
            helperText={showError ? fieldError : helperText}
        />
    );
};

export const replaceWithFillInTheBlank = (str: string, find: string): any => {
    if (!str) return;

    const parts = str.split(find);
    const result = [];

    const replaceValue = (key: string) => (
        <span
            key={key}
            style={{
                borderBottom: "1px solid black",
                width: "40px",
                display: "inline-block",
                marginBottom: "-5px",
            }}
        ></span>
    );
    for (let i = 0; i < parts.length; i++) {
        result.push(parts[i]);
        if (i < parts.length - 1) result.push(replaceValue(i.toString()));
    }
    return result;
};
